export default {
  methods: {
    getLayerType(layer) {
      if (!layer) return;
      return layer.type === 'features_layer' ? layer.geometry_type : layer.service_type;
    },
    getLayerIcon(layerType) {
      if (layerType === 'point' || layerType === 'multipoint') {
        return 'mdi-circle-medium';
      } else if (layerType === 'linestring' || layerType === 'multilinestring') {
        return 'mdi-chart-line-variant';
      } else if (layerType === 'polygon' || layerType === 'multipolygon') {
        return 'mdi-square-rounded';
      } else if (layerType === 'xyz' || layerType === 'wms' || layerType === 'wmts') {
        return '$wms';
      } else {
        return 'mdi-table-large';
      }
    },
    getLayerStylesList(layer) {
      if (!layer.style?.uniques && !layer.style?.ranges) return;
      return (layer.style.uniques ? this.$_objectToArray(layer.style.uniques.values) : layer.style.ranges.values).map(
        value => {
          return {
            ...value,
            key: value.label || value.label === '' ? value.label : value.value,
          };
        }
      );
    },
    getStyleExternalGraphicIcon(name) {
      return `${process.env.VUE_APP_MAIN_API_URL}/icons/${name}`;
    },
    getStyleIconColor(style, isGeom = true) {
      if (style && isGeom) {
        return style['fill-color'] || style['circle-color'] || style['line-color'] || '#000000';
      } else {
        return 'rgba(0, 0, 0, 0.7)';
      }
    },
  },
};
